module.exports = __webpack_public_path__ + "public/images/about-3.9dbc2ff8e1d76d0b5a4f2c07c61b3813.jpg";